export const getCurrentUrl = () => {
  if (typeof window !== 'undefined') {
    return `${window.location.href}`
  }
}

export const getCurrentHref = () => {
  if (typeof window !== 'undefined') {
    return `${window.location.href}`
  }
}

export const isFacebookApp = () => {
  if (typeof window !== 'undefined') {
    return navigator.userAgent.match(/FBAV|FBAN/i)
  }
}
